export const INDUSTRY = [
    {
        label: 'Autos (Sales and Service)',
        value: 1
    },
    {
        label: 'Building Services',
        value: 2
    },
    {
        label: 'Digital Products',
        value: 3
    },
    {
        label: 'Education',
        value: 4
    },
    {
        label: 'Entertainment And Recreation',
        value: 5
    },
    {
        label: 'Financial Services',
        value: 6
    },
    {
        label: 'Food And Drink',
        value: 7
    },
    {
        label: 'Medical Services',
        value: 8
    },
    {
        label: 'Membership Organizations',
        value: 9
    },
    {
        label: 'Personal Services',
        value: 10
    },
    {
        label: 'Professional Services',
        value: 11
    },
    {
        label: 'Regulated And Age-Restricted Products',
        value: 12
    },
    {
        label: 'Retail',
        value: 13
    },
    {
        label: 'Transportation',
        value: 14
    },
    {
        label: 'Travel and Lodging',
        value: 15
    },
    {
        label: 'Other',
        value: 0
    }
];

export const MCC_CATEGORIES = [
    {
        label: 'Agricultural Services',
        mcc_code_range: '0001–1499'
    },
    {
        label: 'Contracted Services',
        mcc_code_range: '1500–2999'
    },
    {
        label: 'Transportation Services',
        mcc_code_range: '4000–4799'
    },
    {
        label: 'Utility Services',
        mcc_code_range: '4800–4999'
    },
    {
        label: 'Retail Outlet Services',
        mcc_code_range: '5000–5599'
    },
    {
        label: 'Clothing Stores',
        mcc_code_range: '5600–5699'
    },
    {
        label: 'Miscellaneous Stores',
        mcc_code_range: '5700–7299'
    },
    {
        label: 'Business Services',
        mcc_code_range: '7300–7999'
    },
    {
        label: 'Professional Services and Membership Organizations',
        mcc_code_range: '8000–8999'
    },
    {
        label: 'Government Services',
        mcc_code_range: '9000–9999'
    },
    {
        label: 'Other',
        mcc_code_range: 0
    },
]